import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	callout: {
		id: 'freeTrialPlans.planPicker.freeTrial.banner',
		defaultMessage: 'Limited Time Offer',
		description: 'Free trial banner',
	},
	simplifiedFTUEheading: {
		id: 'onboarding.upsell.heading',
		defaultMessage: 'Try Calm Premium for Free',
		description: 'Heading for the premium upsell page',
	},
	extendedTrialHeading: {
		id: 'signup.upsell.extendedTrialHeading',
		defaultMessage: 'Try Calm Premium for {br} {amount} days',
		description: 'Inform the user how many days long their trial is',
	},
	directSubHeading: {
		id: 'signup.upsell.directSubHeading',
		defaultMessage: 'Get Calm Premium',
		description: 'Tells the user that they are getting a premium subscription',
	},
});
